import React, { Component } from 'react'
import { renderRoutes } from 'react-router-config'

//import UniversalComponent from './UniversalComponent'

class Root extends Component {
  render() {
    const { route, children } = this.props

    return (
      <div>
        {/*<UniversalComponent name='universal' />*/}
        {renderRoutes(route.routes)}
        {children}
      </div>
    )
  }
}

export default Root
